<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-right">
          <router-link class="btn btn-primary" :to="{ name: 'reminders.create' }">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Create
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-10">
        <advanced-filter
          ref="advancedFilter"
          :refs="$refs"
          :select-filters="selectFilters"
          :date-range="true"
          @ready="setDefaultFilters"
        />

        <v-server-table
          v-if="initialised"
          ref="table"
          :url="query"
          :columns="columns"
          :options="options"
        />
      </div>

      <div class="col-2">
        <user-list :query="{ reminded: 1 }" :click-action="clickUser" @reset="reset" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import moment from "moment";
import entity from "../../mixins/entity";
import format from "../../mixins/format";
import UserList from "../../components/common/UserList.vue";
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

const columns = [
  "important",
  "created_at",
  "created_by",
  "due_date",
  "user_id",
  "job_id",
  "jobs|status",
  "resolved_at",
  "brand_id",
  "action",
  "notes",
  "edit",
];

export default {
  components: {
    AdvancedFilter,
    UserList,
  },

  mixins: [entity, format],

  data() {
    return {
      initialised: false,
      userFilter: null,

      selectFilters: {
        assigned_to: {
          options: [
            {
              label: "My Reminders",
              value: "mine",
            },
          ],
        },

        resolved: {
          options: [
            {
              label: "Pending",
              value: "pending",
            },
            {
              label: "Resolved",
              value: "resolved",
            },
          ],
        },
      },

      columns,
      options: {
        advancedFilter: true,

        columnsClasses: {
          edit: "text-center",
        },

        headings: {
          created_at: () => "Created At",
          user_id: () => "Assigned To",
          job_id: () => "Job",
          "jobs|status": () => "Job Status",
          resolved_at: () => "Resolved?",
          brand_id: () => "Brand",
        },

        sortable: [
          "important",
          "created_at",
          "created_by",
          "due_date",
          "user_id",
          "job_id",
          "jobs|status",
          "resolved_at",
          "action",
          "notes",
        ],

        templates: {
          /* eslint-disable no-confusing-arrow */
          created_at: (h, o) => this.formatLocalDate(o.created_at, "DD MMM YYYY@hh:mma"),
          created_by: (h, o) => o.creator.name,
          due_date: (h, o) => this.formatLocalDate(o.due_date, "DD/MM/YYYY"),
          user_id: (h, o) => o.user.name,
          job_id: (h, o) =>
            o.job_id
              ? h(
                  "a",
                  {
                    attrs: {
                      href: `/jobs/${o.job_id}/edit`,
                      target: "_blank",
                    },
                  },
                  `#${o.job_id}J`
                )
              : "N/A",
          "jobs|status": (h, o) => (o.job_id ? o.job.status : "N/A"),
          resolved_at: (h, o) => (o.resolved ? "Yes" : "No"),
          important: (h, o) => {
            if (o.important) {
              return h("font-awesome-icon", {
                class: ["text-danger"],
                props: {
                  icon: ["fal", "exclamation-triangle"],
                },
              });
            }

            return "";
          },
          brand_id: (h, o) => (o.job && o.job.brand ? o.job.brand.name : "N/A"),
          edit: (h, o) => this.entityEdit(h, o, "reminders", this.$refs),
        },
      },
    };
  },

  computed: {
    query() {
      if (this.userFilter && this.userFilter.id) {
        return `/reminders?with=user;creator;job.brand&user_id=${this.userFilter.id}`;
      }

      return "/reminders?with=user;creator;job.brand";
    },
  },

  methods: {
    clickUser(user) {
      this.userFilter = user;
    },

    reset() {
      this.userFilter = null;
    },

    setDefaultFilters() {
      if (!this.$refs.advancedFilter) {
        return;
      }

      if (this.$refs.advancedFilter.to === "") {
        this.$store.state["advanced-filter"].to = moment().format("YYYY-MM-DD");
        this.$refs.advancedFilter.to = moment().format("YYYY-MM-DD");
      }

      if (this.$refs.advancedFilter.selectFilterValues.resolved === "") {
        this.$refs.advancedFilter.selectFilterValues.resolved = "pending";
      }

      this.initialised = true;
    },
  },
};
</script>
